import { z } from 'zod';

/** The new end date and the reason are both required; the date must also be after the current end date (the dialog knows it). */
export const ProbationReviewExtendFormData = z.object({
  newEndDate: z
    .string()
    .default('')
    .refine(value => value.length > 0, { message: 'Select the new end date' }),
  reason: z
    .string()
    .default('')
    .refine(value => value.trim().length > 0, { message: 'Enter the reason' }),
});
export type ProbationReviewExtendFormDataType = z.infer<typeof ProbationReviewExtendFormData>;
